import React from "react";
import { NavLink } from "react-router-dom";
import {
  HomeOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  CarOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import "./MobileBottomNav.css";

const ITEMS = [
  { key: "home", label: "Trang chủ", path: "/", Icon: HomeOutlined },
  { key: "ecommerce", label: "Kênh bán", path: "/ecommerce", Icon: AppstoreOutlined },
  { key: "order", label: "Đơn hàng", path: "/order", Icon: ShoppingCartOutlined },
  { key: "shipping", label: "Vận chuyển", path: "/vanchuyen", Icon: CarOutlined },
  { key: "inventory", label: "Kho hàng", path: "/inventory", Icon: DatabaseOutlined },
];

export default function MobileBottomNav({ isMobile }) {
  if (!isMobile) return null;

  return (
    <nav className="mobile-bottom-nav" role="navigation" aria-label="Điều hướng chính">
      {ITEMS.map((item) => {
        const Icon = item.Icon;
        return (
          <NavLink
            key={item.key}
            to={item.path}
            className={({ isActive }) =>
              "mobile-bottom-nav__item" + (isActive ? " mobile-bottom-nav__item--active" : "")
            }
            end={item.path === "/"}
          >
            <span className="mobile-bottom-nav__icon">
              <Icon />
            </span>
            <span className="mobile-bottom-nav__label">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
